module.exports = __webpack_public_path__ + "static/Harry-937869af14991e6987ba877d58f17f0a.jpg";